'use strict';
define('global/document', ['global/window'], function (window) {
    return window.document;
});

